
import { defineComponent, reactive, toRef, ref } from 'vue';
import Child from './components/Child.vue'
export default defineComponent({
    name: 'App',
    components: {
        Child,
    },
    setup() {
        const state = reactive({
            age: 5,
            money: 100,
        })
        const age = toRef(state, 'age');
        const money = ref(state.money);
        const update = () => {
            state.age = 10;
            age.value = 15;
            money.value += 100;
            console.log(age, money);
        }
        return {
            state,
            age,
            money,
            update,
        }
    }
});
